<div class="dtfuseAndPrivacy" *ngIf="isCanadaPortal">
    <!--Announcement Banner Code-->
    <div class="dtf-alertpage"></div>
  
  
    <!--Banner-->
    <section class="mbfs-home-hero"
      style="background-image: url(/static/assets/img/dtf-assets/images/redesign/DTF_Terms-Privacy_Header.jpg);">
      <section class="mbfs-home-hero__header">
        <h2 class="mbfs-home-hero__header-subtitle" style="text-align:center;padding: 150px;">
          {{ 'PrivacyPolicy.TermsPrivacyTitle' | translate }}
        </h2>
       
      </section>
    </section>
  
    <section class='mbfs-repay-banner-inner' style="padding-top: 21px; padding-bottom: 15px; padding-left: 21px;">
          <h4 style="text-align:left ;padding-top: 81px; padding-left: 81px;">
            {{ 'PrivacyPolicy.TermsPrivacyHeader' | translate }}
          </h4>
          
    </section>
    
    
    <div class="mbfs-repay-banner-inner__header-text2" style="padding-top: 21px; padding-bottom: 15px; padding-left: 81px;  padding-right: 81px;">
            <p class="mbfs-repay-banner-inner__header-text2">{{ 'PrivacyPolicy.TermsPrivacyCopy1' | translate }}</p>
            <p>{{ 'PrivacyPolicy.TermsPrivacyCopy3' | translate}}</p>
            <div>
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy4' | translate }}</p><br>
        <p> {{ 'PrivacyPolicy.TermsPrivacyCopy79' | translate }}</p>  
        </div>
         <div>  
          <mat-accordion>
            <mat-expansion-panel hideToggle>
              <mat-expansion-panel-header [collapsedHeight]="'auto'" [expandedHeight]="'auto'">
                <mat-panel-title>
                <b><p>{{ 'PrivacyPolicy.TermsPrivacyCopy14' | translate }}</p></b><br> 
                </mat-panel-title>
                <mat-panel-description>
                  
                </mat-panel-description>
              </mat-expansion-panel-header>
              <b><p>{{ 'PrivacyPolicy.TermsPrivacyCopy15' | translate }}</p></b>
              <p>{{ 'PrivacyPolicy.TermsPrivacyCopy17' | translate }}</p>
             <p>{{ 'PrivacyPolicy.TermsPrivacyCopy18' | translate }}</p>
              <p>{{ 'PrivacyPolicy.TermsPrivacyCopy19' | translate }}</p>
             <p>{{ 'PrivacyPolicy.TermsPrivacyCopy21' | translate }}</p>
              <p>{{ 'PrivacyPolicy.TermsPrivacyCopy22' | translate }}</p>
             <p>{{ 'PrivacyPolicy.TermsPrivacyCopy23' | translate }}</p>
             <p>{{ 'PrivacyPolicy.TermsPrivacyCopy24' | translate }}</p>
              <p>{{ 'PrivacyPolicy.TermsPrivacyCopy26' | translate }}</p>
             <p>{{ 'PrivacyPolicy.TermsPrivacyCopy27' | translate }}</p>
               <p>{{ 'PrivacyPolicy.TermsPrivacyCopy28' | translate }}</p>
            </mat-expansion-panel>       
          </mat-accordion>    
        </div>
        <div>
          <mat-accordion>
            <mat-expansion-panel hideToggle>
              <mat-expansion-panel-header [collapsedHeight]="'auto'" [expandedHeight]="'auto'">
                <mat-panel-title>
                  <b><p>{{ 'PrivacyPolicy.TermsPrivacyCopy29' | translate }}</p></b><br>
                </mat-panel-title>
                <mat-panel-description>
                  
                </mat-panel-description>
              </mat-expansion-panel-header>
        <b><p>{{ 'PrivacyPolicy.TermsPrivacyCopy30' | translate }}</p></b>
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy31' | translate }}</p>
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy32' | translate }}</p>        
        <p >{{ 'PrivacyPolicy.TermsPrivacyCopy33' | translate }}</p>
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy34' | translate }}</p>
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy35' | translate }}</p>
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy36' | translate }}</p>
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy37' | translate }}</p>
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy38' | translate }}</p>
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy39' | translate }}</p>
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy40' | translate }}</p>
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy41' | translate }}</p>
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy42' | translate }}</p>
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy43' | translate }}</p>
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy44' | translate }}</p>
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy45' | translate }}</p>
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy46' | translate }}</p>
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy47' | translate }}</p>
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy48' | translate }}</p>        
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy49' | translate }}</p>
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy50' | translate }}</p>
      </mat-expansion-panel>       
    </mat-accordion>
        </div>
        <div>
        <mat-accordion>
            <mat-expansion-panel hideToggle>
              <mat-expansion-panel-header [collapsedHeight]="'auto'" [expandedHeight]="'auto'">
                <mat-panel-title>
        <b><p>{{ 'PrivacyPolicy.TermsPrivacyCopy51' | translate }}</p></b><br>
      </mat-panel-title>
      <mat-panel-description>
        
      </mat-panel-description>
    </mat-expansion-panel-header>
       <b><p>{{ 'PrivacyPolicy.TermsPrivacyCopy52' | translate }}</p></b> 
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy53' | translate }}</p>
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy54' | translate }}</p>
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy55' | translate }}</p>
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy56' | translate }}</p>
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy57' | translate }}</p>
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy58' | translate }}</p>
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy59' | translate }}</p>
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy60' | translate }}</p>
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy61' | translate }}</p>
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy62' | translate }}</p>
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy63' | translate }}</p>
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy65' | translate }}</p>
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy71' | translate }}</p>
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy72' | translate }}</p>
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy66' | translate }}</p>
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy67' | translate }}</p>
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy68' | translate }}</p>
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy69' | translate }}</p>
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy70' | translate }}</p>
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy73' | translate }}</p>
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy74' | translate }}</p>
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy75' | translate }}</p>
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy76' | translate }}</p>            
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy77' | translate }}</p>
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy78' | translate }}</p>
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy81' | translate }}</p>
        <p>{{ 'PrivacyPolicy.TermsPrivacyCopy82' | translate }}</p>
        </mat-expansion-panel>       
      </mat-accordion>
          </div>
          <div>
            <mat-accordion>
              <mat-expansion-panel hideToggle>
                <mat-expansion-panel-header [collapsedHeight]="'auto'" [expandedHeight]="'auto'">
                  <mat-panel-title>
         <b><p>{{ 'PrivacyPolicy.TermsPrivacyCopy83' | translate }}</p></b><br>
        </mat-panel-title>
        <mat-panel-description>
          
        </mat-panel-description>
      </mat-expansion-panel-header>
          <b><p>{{ 'PrivacyPolicy.TermsPrivacyCopy84' | translate }}</p></b>
          <p>{{ 'PrivacyPolicy.TermsPrivacyCopy85' | translate }}</p>
          <p>{{ 'PrivacyPolicy.TermsPrivacyCopy86' | translate }}</p>
        </mat-expansion-panel>       
      </mat-accordion>
          </div>
          <div>
            <mat-accordion>
              <mat-expansion-panel hideToggle>
                <mat-expansion-panel-header [collapsedHeight]="'auto'" [expandedHeight]="'auto'">
                  <mat-panel-title>
          <b><p>{{ 'PrivacyPolicy.TermsPrivacyCopy87' | translate }}</p></b><br>
        </mat-panel-title>
        <mat-panel-description>
          
        </mat-panel-description>
      </mat-expansion-panel-header>
         <b><p>{{ 'PrivacyPolicy.TermsPrivacyCopy88' | translate }}</p></b>
          <p>{{ 'PrivacyPolicy.TermsPrivacyCopy89' | translate }}</p>
          <p>{{ 'PrivacyPolicy.TermsPrivacyCopy90' | translate }}</p>
        </mat-expansion-panel>       
      </mat-accordion>
        </div>
        <div>
          <mat-accordion>
            <mat-expansion-panel hideToggle>
              <mat-expansion-panel-header [collapsedHeight]="'auto'" [expandedHeight]="'auto'">
                <mat-panel-title>
          <b><p>{{ 'PrivacyPolicy.TermsPrivacyCopy91' | translate }}</p></b><br>
        </mat-panel-title>
        <mat-panel-description>
          
        </mat-panel-description>
      </mat-expansion-panel-header>
          <b><p>{{ 'PrivacyPolicy.TermsPrivacyCopy92' | translate }}</p></b>
          <p>{{ 'PrivacyPolicy.TermsPrivacyCopy93' | translate }}</p>
          <p>{{ 'PrivacyPolicy.TermsPrivacyCopy94' | translate }}</p>
        </mat-expansion-panel>       
      </mat-accordion>
          </div>
          <div>
            <mat-accordion>
              <mat-expansion-panel hideToggle>
                <mat-expansion-panel-header [collapsedHeight]="'auto'" [expandedHeight]="'auto'">
                  <mat-panel-title>
          <b><p>{{ 'PrivacyPolicy.TermsPrivacyCopy95' | translate }}</p></b><br>
        </mat-panel-title>
        <mat-panel-description>
          
        </mat-panel-description>
      </mat-expansion-panel-header>
        <b><p>{{ 'PrivacyPolicy.TermsPrivacyCopy96' | translate }}</p></b>
          <p>{{ 'PrivacyPolicy.TermsPrivacyCopy97' | translate }}</p>
          <p>{{ 'PrivacyPolicy.TermsPrivacyCopy98' | translate }}</p>
          <p>{{ 'PrivacyPolicy.TermsPrivacyCopy99' | translate }}</p>
        </mat-expansion-panel>       
      </mat-accordion>
          </div>
          <div>
            <mat-accordion>
              <mat-expansion-panel hideToggle>
                <mat-expansion-panel-header [collapsedHeight]="'auto'" [expandedHeight]="'auto'">
                  <mat-panel-title>
          <b><p>{{ 'PrivacyPolicy.TermsPrivacyCopy100' | translate }}</p></b><br> 
        </mat-panel-title>
        <mat-panel-description>
          
        </mat-panel-description>
      </mat-expansion-panel-header>              
          <b><p>{{ 'PrivacyPolicy.TermsPrivacyCopy1015' | translate }}</p></b>       
          <p>{{ 'PrivacyPolicy.TermsPrivacyCopy101' | translate }}</p>
          <p>{{ 'PrivacyPolicy.TermsPrivacyCopy102' | translate }}</p>
        </mat-expansion-panel>       
      </mat-accordion>
        </div>
           <div>
            <mat-accordion>
              <mat-expansion-panel hideToggle>
                <mat-expansion-panel-header [collapsedHeight]="'auto'" [expandedHeight]="'auto'">
                  <mat-panel-title>
        <b><p>{{ 'PrivacyPolicy.TermsPrivacyCopy103' | translate }}</p></b><br>
        </mat-panel-title>
        <mat-panel-description>
          
        </mat-panel-description>
      </mat-expansion-panel-header>   
         <b><p>{{ 'PrivacyPolicy.TermsPrivacyCopy104' | translate }}</p></b>                           
          <p>{{ 'PrivacyPolicy.TermsPrivacyCopy105' | translate }}</p>
          <p>{{ 'PrivacyPolicy.TermsPrivacyCopy106' | translate }}</p>                               
          <p>{{ 'PrivacyPolicy.TermsPrivacyCopy107' | translate }}</p>
          <p>{{ 'PrivacyPolicy.TermsPrivacyCopy108' | translate }}</p>
           <p>{{ 'PrivacyPolicy.TermsPrivacyCopy109' | translate }}</p>
           <p>{{ 'PrivacyPolicy.TermsPrivacyCopy110' | translate }}</p>
          </mat-expansion-panel>       
        </mat-accordion>
          </div>
           <div>
            <mat-accordion>
              <mat-expansion-panel hideToggle>
                <mat-expansion-panel-header [collapsedHeight]="'auto'" [expandedHeight]="'auto'">
                  <mat-panel-title>
          <b><p>{{ 'PrivacyPolicy.TermsPrivacyCopy111' | translate }}</p></b><br>
          </mat-panel-title>
          <mat-panel-description>
            
          </mat-panel-description>
        </mat-expansion-panel-header>  
           <p>{{ 'PrivacyPolicy.TermsPrivacyCopy112' | translate }}</p>
           <p>{{ 'PrivacyPolicy.TermsPrivacyCopy113' | translate }}</p>
           <p>{{ 'PrivacyPolicy.TermsPrivacyCopy114' | translate }}</p>          
           <p>{{ 'PrivacyPolicy.TermsPrivacyCopy115' | translate }}</p>
           <p>{{ 'PrivacyPolicy.TermsPrivacyCopy116' | translate }}</p>
           <p>{{ 'PrivacyPolicy.TermsPrivacyCopy117' | translate }}</p>
           <p>{{ 'PrivacyPolicy.TermsPrivacyCopy118' | translate }}</p>
           <p>{{ 'PrivacyPolicy.TermsPrivacyCopy119' | translate }}</p>
           <p>{{ 'PrivacyPolicy.TermsPrivacyCopy120' | translate }}  <a href="https://www.priv.gc.ca/en/about-the-opc/" target=_blank>https://www.priv.gc.ca/en/about-the-opc/</a></p>
           <p>{{ 'PrivacyPolicy.TermsPrivacyCopy121' | translate }} <a href="cai.communications@cai.gouv.qc.ca " target=_blank>cai.communications&#64;cai.gouv.qc.ca </a>{{ 'PrivacyPolicy.TermsPrivacyCopy126' | translate }}</p>

           <p>{{ 'PrivacyPolicy.TermsPrivacyCopy122' | translate }} <a href="https://www.cai.gouv.qc.ca/"target=_blank>https://www.cai.gouv.qc.ca/</a></p>
           <p>{{ 'PrivacyPolicy.TermsPrivacyCopy123' | translate }} <a href="generalinfo@oipc.ab.ca"target=_blank>generalinfo&#64;oipc.ab.ca</a> {{ 'PrivacyPolicy.TermsPrivacyCopy130' | translate }}</p>
           <p>{{ 'PrivacyPolicy.TermsPrivacyCopy124' | translate }} <a href="https://www.oipc.bc.ca/"target=_blank>https://www.oipc.bc.ca/</a></p>
           <p>{{ 'PrivacyPolicy.TermsPrivacyCopy131' | translate }} <a href="info@oipc.bc.ca"target=_blank>info&#64;oipc.bc.ca/</a></p>
           <p>{{ 'PrivacyPolicy.TermsPrivacyCopy132' | translate }} <a href="https://www.oipc.bc.ca/"target=_blank>https://www.oipc.bc.ca/</a></p>
          </mat-expansion-panel>       
        </mat-accordion>
          </div>
   </div>     
        
</div>
   